<template>
  <div class="background">
    <div class="background-layer background-layer-garland garland"></div>
    <div class="background-layer background-layer-2"></div>

    <div class="lightbulb lightbulb-blue lightbulb-blue-1">
      <img src="@/assets/img/mandarin-prediction/lightbulb-blue.png" />
    </div>

    <div class="background-layer background-layer-3"></div>

    <div class="lightbulb lightbulb-yellow lightbulb-yellow-1">
      <img src="@/assets/img/mandarin-prediction/lightbulb-yellow.png" />
    </div>

    <div class="background-layer background-layer-4"></div>
    <div class="background-layer background-layer-5"></div>

    <div class="lightbulb lightbulb-green lightbulb-green-1">
      <img src="@/assets/img/mandarin-prediction/lightbulb-green.png" />
    </div>

    <div class="lightbulb lightbulb-blue lightbulb-blue-2">
      <img src="@/assets/img/mandarin-prediction/lightbulb-blue.png" />
    </div>

    <div class="background-layer background-layer-garland-2 garland"></div>

    <div class="lightbulb lightbulb-yellow lightbulb-yellow-2">
      <img src="@/assets/img/mandarin-prediction/lightbulb-yellow.png" />
    </div>

    <div class="background-layer background-layer-6"></div>

    <div class="lightbulb lightbulb-yellow lightbulb-yellow-3">
      <img src="@/assets/img/mandarin-prediction/lightbulb-yellow.png" />
    </div>

    <app-btn class="button--start">
      <div
        class="button-content"
        @click="$router.push({ name: 'Predictions' })"
      >
        Начать
      </div>
    </app-btn>
  </div>
</template>

<script>
import AppBtn from '@/components/UI/buttons/AppBtn.vue'
export default {
  name: 'StartMandarinPrediction',
  components: { AppBtn },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mandarin-prediction/_fonts.scss';
@import '@/assets/scss/mandarin-prediction/_base.scss';

.background {
  background-image: url('~@/assets/img/mandarin-prediction/start/layer-1.png'),
    url('~@/assets/img/mandarin-prediction/background.png');

  &-layer {
    &-garland {
      width: 122vw;
      height: 100vh;
      top: 9vw;
      left: -1vw;
      background-size: contain;
    }

    &-garland-2 {
      width: 122vw;
      height: 100vh;
      top: -39.5vw;
      left: -5.2vw;
      background-size: contain;
    }

    &-2 {
      background-image: url('~@/assets/img/mandarin-prediction/start/layer-2.png');
    }

    &-3 {
      background-image: url('~@/assets/img/mandarin-prediction/start/layer-3.png');
    }

    &-4 {
      background-image: url('~@/assets/img/mandarin-prediction/start/layer-4.png');
    }

    &-5 {
      background-image: url('~@/assets/img/mandarin-prediction/start/layer-5.png');
    }

    &-6 {
      background-image: url('~@/assets/img/mandarin-prediction/start/layer-6.png');
    }
  }
}

.button--start {
  background: #fff;
  color: #7dce18;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 100;
  font-family: 'M Plus Rounded 1c', sans-serif;
  font-weight: 800;
  font-size: 1.7vw;
  padding: 1.6vw 5vw;
  border-radius: 55px;
}

.lightbulb-blue-1 {
  width: 24vw;
  bottom: 35vh;
  left: -11.6vw;
  transform: rotate(-29.16deg);
}

.lightbulb-blue-2 {
  width: 22vw;
  top: 2vh;
  right: 11vw;
  transform: rotate(-113.63deg);
}

.lightbulb-yellow-1 {
  width: 22.6vw;
  bottom: 9.6vh;
  left: 10.5vw;
  transform: rotate(55.39deg);
}

.lightbulb-yellow-2 {
  width: 22.6vw;
  top: -8.1vh;
  left: 21.1vw;
  transform: rotate(-9.25deg);
}

.lightbulb-yellow-3 {
  width: 22.6vw;
  top: -17.4vh;
  right: -11.3vw;
  transform: rotate(39.62deg);
}

.lightbulb-green-1 {
  width: 23.4vw;
  top: -8.6vh;
  left: -7.2vw;
  transform: rotate(-64.17deg);
}

@media (min-width: 769px) and (max-width: 1024px) and (orientation: portrait) {
  .background {
    background-image: url('~@/assets/img/mandarin-prediction/start/layer-1-tablet.png'),
      url('~@/assets/img/mandarin-prediction/background.png');

    &-layer {
      &-garland {
        width: 229vw;
        height: 100vh;
        top: 22vw;
        left: -49.8vw;
      }

      &-garland-2 {
        width: 229vw;
        height: 100vh;
        top: -70vw;
        left: -56vw;
      }

      &-2,
      &-3,
      &-5 {
        display: none;
      }

      &-4 {
        background-image: url('~@/assets/img/mandarin-prediction/start/layer-4-tablet.png');
      }
      &-6 {
        background-image: url('~@/assets/img/mandarin-prediction/start/layer-6-tablet.png');
      }
    }
  }

  .lightbulb-blue-1,
  .lightbulb-green-1,
  .lightbulb-green-2,
  .lightbulb-yellow-1,
  .lightbulb-yellow-2 {
    display: none;
  }

  .lightbulb-blue-2 {
    width: 43vw;
    top: 5vh;
    right: -22.1vw;
    transform: rotate(-113.63deg);
  }

  .lightbulb-yellow-3 {
    width: 40.8vw;
    top: 7.1vh;
    left: -8vw;
    transform: rotate(-9.25deg);
  }

  .button--start {
    bottom: 125px;
    font-size: 29px;
    padding: 29px 85px;
  }
}

@media (max-width: 768px) and (orientation: portrait) {
  .background {
    background-image: url('~@/assets/img/mandarin-prediction/start/layer-1-mobile.png'),
      url('~@/assets/img/mandarin-prediction/background.png');

    &-layer {
      &-garland {
        width: 229vw;
        height: 100vh;
        top: 12vw;
        left: -49.8vw;
      }

      &-garland-2 {
        width: 229vw;
        height: 100vh;
        top: -80vw;
        left: -56vw;
      }

      &-2,
      &-3,
      &-5 {
        display: none;
      }

      &-4 {
        background-image: url('~@/assets/img/mandarin-prediction/start/layer-4-mobile.png');
      }
      &-6 {
        background-image: url('~@/assets/img/mandarin-prediction/start/layer-6-mobile.png');
      }
    }
  }

  .lightbulb-blue-1,
  .lightbulb-green-1,
  .lightbulb-green-2,
  .lightbulb-yellow-1,
  .lightbulb-yellow-3 {
    display: none;
  }

  .lightbulb-blue-2 {
    width: 43vw;
    top: 21vh;
    right: -16.1vw;
    transform: rotate(-113.63deg);
  }

  .lightbulb-yellow-2 {
    width: 40.8vw;
    top: 17.1vh;
    left: -8vw;
    transform: rotate(-9.25deg);
  }

  .button--start {
    bottom: 150px;
    font-size: 21px;
    padding: 20px 60px;
  }
}
</style>
